module.exports = __webpack_public_path__ + "img/logo-grupo-nabeiro.16942da3.png";